import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ACTIVE_URL } from "@/constants";
import type { NewsItem } from "./news";

export function NewsDetail() {
  const { id } = useParams();
  const [item, setItem] = useState<NewsItem | null>(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true);
    setNotFound(false);
    fetch(`${ACTIVE_URL}/api/news/${id}/`)
      .then(r => {
        if (!r.ok) throw new Error("not found");
        return r.json();
      })
      .then(setItem)
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <div className="page-root">
      <div className="relative z-10 max-w-[800px] mx-auto px-6 md:px-8 py-24 min-h-screen">
        <Link
          to="/ta-nea-mas"
          className="inline-flex items-center gap-1 text-white/50 hover:text-[#00d9d9] text-sm mb-10 transition-colors duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
          Πίσω στα νέα
        </Link>

        {loading ? (
          <div className="flex flex-col gap-6 animate-pulse">
            <div className="h-4 w-32 bg-white/10 rounded" />
            <div className="h-10 w-3/4 bg-white/10 rounded" />
            <div className="h-80 w-full bg-white/5 rounded-2xl" />
          </div>
        ) : notFound || !item ? (
          <div className="flex flex-col items-center justify-center py-24 text-white/40">
            <p className="text-lg">Το άρθρο δεν βρέθηκε.</p>
          </div>
        ) : (
          <article className="flex flex-col gap-6">
            <p className="text-sm text-white/40">
              {new Date(item.created_at).toLocaleDateString("el-GR", { day: "numeric", month: "long", year: "numeric" })}
            </p>
            <h1 className="text-3xl lg:text-5xl font-bold text-white leading-tight">{item.title}</h1>
            {item.image_url && (
              <div className="w-full overflow-hidden rounded-2xl border border-white/10">
                <img src={item.image_url} alt={item.title} className="w-full max-h-[480px] object-cover" />
              </div>
            )}
            {item.description && (
              <p className="text-white/70 text-lg leading-relaxed whitespace-pre-line">{item.description}</p>
            )}
            {/* External link, disabled for now — news opens on its own page instead.
            {item.link && (
              <a
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 text-[#00d9d9] font-medium"
              >
                Μάθε περισσότερα
              </a>
            )}
            */}
          </article>
        )}
      </div>
    </div>
  );
}
